module.exports = __webpack_public_path__ + "img/login-backdrop-old.f27fdbe2.png";